import { TCheckboxType } from '@r1-frontend/ui-react/components/controls/baseCheckbox';

import * as ST from './styled';

export interface ICheckboxItem {
    id: string,
    checked: boolean,
    checkType?: TCheckboxType,
    disabled: boolean,
    label: string,
}

interface IPropsCheckboxFilters {
    items: ICheckboxItem[],
    onChange: (id: string) => void,
    className?: string,
}

export const CheckboxFilters = ({ items, onChange, className }: IPropsCheckboxFilters): JSX.Element => {
    return (
        <ST.CheckboxFilters className={className}>
            {items.map(item => {
                return (
                    <ST.CheckboxWrap
                        key={item.id}
                    >
                        <ST.SBaseCheckbox
                            id={item.id}
                            checkType={item.checkType}
                            checked={item.checked}
                            disabled={item.disabled}
                            onChange={() => onChange(item.id)}
                        >
                            {item.label}
                        </ST.SBaseCheckbox>
                    </ST.CheckboxWrap>
                );
            })}
        </ST.CheckboxFilters>
    );
};
